module.exports = __webpack_public_path__ + "static/media/29ADMSPC1.b5ae1196.jpg";